import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { addRosterRecurringEventsAPI, addUpdateRosterEventAPI, deleteRosterEventAPI, fetchPracticeMachinesAPI, fetchPracticeUsersAPI, fetchRosterAPI } from '../../services/roster-service';

import {
    ADD_ROSTER_RECURRING_EVENTS,
    ADD_ROSTER_RECURRING_EVENTS_ERROR,
    ADD_ROSTER_RECURRING_EVENTS_START,
    ADD_ROSTER_RECURRING_EVENTS_SUCCESS,
    ADD_UPDATE_ROSTER_EVENT,
    ADD_UPDATE_ROSTER_EVENT_ERROR,
    ADD_UPDATE_ROSTER_EVENT_START,
    ADD_UPDATE_ROSTER_EVENT_SUCCESS,
    DELETE_ROSTER_EVENT,
    DELETE_ROSTER_EVENT_ERROR,
    DELETE_ROSTER_EVENT_START,
    DELETE_ROSTER_EVENT_SUCCESS,
    FETCH_PRACTICE_MACHINES,
    FETCH_PRACTICE_MACHINES_ERROR,
    FETCH_PRACTICE_MACHINES_START,
    FETCH_PRACTICE_MACHINES_SUCCESS,
    FETCH_PRACTICE_USERS,
    FETCH_PRACTICE_USERS_ERROR,
    FETCH_PRACTICE_USERS_START,
    FETCH_PRACTICE_USERS_SUCCESS,
    FETCH_ROSTER, FETCH_ROSTER_ERROR, FETCH_ROSTER_START, FETCH_ROSTER_SUCCESS
} from "../actions/rosterAction";
import { SET_CALENDAR_RESOURCES } from '../actions/receptionist/appointmentsAction';

export function* getPracticeMachines({ practiceId }) {
    try {
        yield put({ type: FETCH_PRACTICE_MACHINES_START })
        yield put({ type: SET_CALENDAR_RESOURCES, calendarResources: [] })
        const response = yield call(fetchPracticeMachinesAPI, practiceId);
        if (response.success) {
            const machines = response.data.map((machine) => {
                return {
                    ...machine,
                    "id": `${machine.machineId}`,
                    "title": `${machine.modalityName} - ${machine.machineName} [${machine.room}]`
                }
            })
            yield put({ type: FETCH_PRACTICE_MACHINES_SUCCESS, machines })
            const calendarResources = response.data.map(machine => {
                return {
                    ...machine,
                    resourceId: machine.machineId,
                    resourceTitle: `${machine.modalityName} - ${machine.machineName} [${machine.room}]`
                }
            });
            yield put({ type: SET_CALENDAR_RESOURCES, calendarResources })
        } else {
            yield put({ type: FETCH_PRACTICE_MACHINES_ERROR, error: response.error })
            message.error('Failed to fetch practice users!');
        }
    } catch (error) {
        yield put({ type: FETCH_PRACTICE_MACHINES_ERROR, error })
        message.error('Failed to fetch practice users!');
    }
}

export function* getPracticeUsers({ practiceId }) {
    try {
        yield put({ type: FETCH_PRACTICE_USERS_START })
        const response = yield call(fetchPracticeUsersAPI, practiceId);
        if (response.success) {
            yield put({ type: FETCH_PRACTICE_USERS_SUCCESS, users: response.data })
        } else {
            yield put({ type: FETCH_PRACTICE_USERS_ERROR, error: response.error })
            message.error('Failed to fetch practice users!');
        }
    } catch (error) {
        yield put({ type: FETCH_PRACTICE_USERS_ERROR, error })
        message.error('Failed to fetch practice users!');
    }
}

export function* getRoster({ payload }) {
    try {
        yield put({ type: FETCH_ROSTER_START })
        const response = yield call(fetchRosterAPI, payload);
        if (response.success) {

            const events = response.data.map(rosterEvent => {
                return {
                    ...rosterEvent,
                    "resourceId": rosterEvent.machineId,
                    "title": rosterEvent.resourceName,
                    "start": rosterEvent.startTime,
                    "end": rosterEvent.endTime
                }
            })

            yield put({ type: FETCH_ROSTER_SUCCESS, events })
        } else {
            yield put({ type: FETCH_ROSTER_ERROR, error: response.error })
            message.error('Failed to fetch roster!');
        }
    } catch (error) {
        yield put({ type: FETCH_ROSTER_ERROR, error })
        message.error('Failed to fetch roster!');
    }
}

export function* addUpdateRosterEvent({ payload }) {
    const { event, eventChangeInfo } = payload;
    try {
        yield put({ type: ADD_UPDATE_ROSTER_EVENT_START })
        const response = yield call(addUpdateRosterEventAPI, event);
        if (response.success) {
            const newEvent = {
                ...response.data,
                "resourceId": response.data.machineId,
                "title": event.title,
                "start": response.data.startTime,
                "end": response.data.endTime
            };
            yield put({ type: ADD_UPDATE_ROSTER_EVENT_SUCCESS, event: newEvent })
        } else {
            eventChangeInfo.revert()
            yield put({ type: ADD_UPDATE_ROSTER_EVENT_ERROR, error: response.error })
            message.error('Failed to add update roster event!');
        }
    } catch (error) {
        eventChangeInfo.revert()
        yield put({ type: ADD_UPDATE_ROSTER_EVENT_ERROR, error })
        message.error('Failed to add update roster event!');
    }
}

export function* deleteRosterEvent({ timeslotId }) {
    try {
        yield put({ type: DELETE_ROSTER_EVENT_START })
        const response = yield call(deleteRosterEventAPI, timeslotId);
        if (response.success) {
            yield put({ type: DELETE_ROSTER_EVENT_SUCCESS, timeslotId })
        } else {
            yield put({ type: DELETE_ROSTER_EVENT_ERROR, error: response.error })
            message.error('Failed to delete roster event!');
        }
    } catch (error) {
        yield put({ type: DELETE_ROSTER_EVENT_ERROR, error })
        message.error('Failed to delete roster event!');
    }
}

export function* addRosterRecurringEvents({ recurringEvents }) {
    try {
        yield put({ type: ADD_ROSTER_RECURRING_EVENTS_START })
        const response = yield call(addRosterRecurringEventsAPI, recurringEvents);
        if (response.success) {
            // will dispatch if required, bcoz anyhow roster calendar is displaying single day
            // yield put({ type: ADD_ROSTER_RECURRING_EVENTS_SUCCESS, recurringEvents: response.data })
        } else {
            yield put({ type: ADD_ROSTER_RECURRING_EVENTS_ERROR, error: response.error })
            message.error('Failed to add recurring events!');
        }
    } catch (error) {
        yield put({ type: DELETE_ROSTER_EVENT_ERROR, error })
        message.error('Failed to add recurring events!');
    }
}


function* rosterWatcher() {
    yield takeLatest(FETCH_PRACTICE_MACHINES, getPracticeMachines)
    yield takeLatest(FETCH_PRACTICE_USERS, getPracticeUsers)
    yield takeLatest(FETCH_ROSTER, getRoster)
    yield takeLatest(ADD_UPDATE_ROSTER_EVENT, addUpdateRosterEvent)
    yield takeLatest(DELETE_ROSTER_EVENT, deleteRosterEvent)
    yield takeLatest(ADD_ROSTER_RECURRING_EVENTS, addRosterRecurringEvents)
}

export default function* rosterSaga() {
    yield all([
        rosterWatcher(),
    ]);
}